<div class="inner-mat-dialog flex justify-between content-stretch items-stretch flex-col">
  <div>
    <h1 mat-dialog-title tabindex="0" class="xs:flex-1 sm:basis-full">
      <span *ngIf="deviceSummary?.edgeDeviceFriendlyName">{{deviceSummary?.edgeDeviceFriendlyName}} - </span>
      <span>{{deviceSummary?.edgeDeviceId}}</span>
    </h1>
  </div>

  <mat-dialog-content>
    <div class="grid xs:grid-cols-1 grid-cols-[repeat(4,_auto)] gap-4 deviceDetails">
      <div>
        <label for="organization">
          Organization
        </label>
        <p id="organization">{{deviceSummary?.organizationId}}</p>
      </div>
      <div>
        <label for="deviceType">
          Device Type
        </label>
        <p id="deviceType">{{deviceSummary?.deviceType}}</p>
      </div>
      <div>
        <label for="osDistro">
          OS Distro
        </label>
        <div *ngIf="!isEditingOsDistro" class="flex items-center gap-1">
          <p id="osDistro">{{deviceSummary?.osDistro}}</p>
          <button *ngIf="canEditOsDistro" mat-icon-button aria-label="Edit OS Distro" (click)="isEditingOsDistro = true">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <div *ngIf="isEditingOsDistro" class="flex items-center gap-1">
          <mat-select
              id="osDistro"
              [value]="deviceSummary?.osDistro"
              (selectionChange)="onOsDistroChange($event.value)"
              class="os_distro_select">
            <mat-option [value]="null">-- None --</mat-option>
            <mat-option *ngFor="let opt of osDistroOptions" [value]="opt">{{opt}}</mat-option>
          </mat-select>
          <button class="CancelEdit" mat-icon-button aria-label="Cancel edit" (click)="cancelOsDistroEdit()">
            <mat-icon class="cancel_icon">cancel</mat-icon>
          </button>
        </div>
      </div>
      <div>
        <label for="connectionState">
          Device Status
        </label>
        <p id="connectionState">{{deviceSummary?.connectionState}}</p>
      </div>
      <div>
        <label for="ipAddress">
          IP Address
        </label>
        <p id="ipAddress">{{deviceSummary?.ipAddress}}</p>
      </div>
      <div>
        <label for="macAddress">
          Mac Address
        </label>
        <p id="macAddress">{{deviceSummary?.macAddress}}</p>
      </div>
      <div>
        <label for="lastDeployed">
          Last Deployed
        </label>
        <p id="lastDeployed">{{deviceSummary?.lastDeployed}}</p>
      </div>
      <div *ngIf="deviceSummary?.connectionState === 'Offline'">
        <label for="lastOnlineTime">
          Last Online Time
        </label>
        <p id="lastOnlineTime"> {{ deviceSummary?.lastOnlineTime | date:'dd-MMM-yyyy hh:mm aaaaa\'m\'' }}</p>
      </div>
      <ng-container *ngFor="let additionalField of deviceSummary?.additionalFields">
        <div>
          <label>
            {{additionalField.name}}
          </label>
          <p>{{additionalField.value}}</p>
        </div>
      </ng-container>
    </div>


    <h6>Product Features</h6>
<span *ngIf="!deviceSummary?.systems?.length">N/A</span>

<!-- Header -->
<div class="grid grid-cols-4 text-sm font-medium border-b border-gray-400 py-2 bg-gray-100">
  <div class="pl-10 basis-[40%]">System Name</div>
  <div class="basis-[20%]">Site</div>
  <div class="basis-[20%]">Serial Number</div>
  <div class="basis-[20%]">Optional Features</div>  
</div>

<!-- Grouped by systemType using mat-accordion -->
<mat-accordion multi>
  <ng-container *ngFor="let systemType of distinctSystemTypes">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ getSystemTypeDisplayName(systemType) }} ({{ getSystemTypeCount(systemType) }})
        </mat-panel-title>
      </mat-expansion-panel-header>

      <ng-container *ngFor="let system of deviceSummary?.systems">
        <div
          *ngIf="getCanonicalSystemType(system.name) === systemType"
          class="grid grid-cols-4 items-center text-sm border-b border-gray-300 py-2"
        >
          <div class="pl-10 basis-[40%] text-ellipsis whitespace-nowrap overflow-hidden"
               [matTooltip]="system.properties.systemFriendlyName?.value || system.systemFriendlyName"
               matTooltipPosition="below"
               matTooltipClass="my-custom-tooltip">
            {{ system.properties.systemFriendlyName?.value || system.systemFriendlyName || 'N/A' }}
          </div>
          <div class="basis-[20%]">{{ system.siteId || 'N/A' }}</div>
          <div class="basis-[20%]">{{ system.systemId || 'N/A' }}</div>
          <div class="basis-[20%]">{{ getFeatureList(system.name, system.features) }}</div>          
        </div>
      </ng-container>

    </mat-expansion-panel>
  </ng-container>
</mat-accordion>

    <h6>Edge Modules</h6>
    <span *ngIf="!deviceSummary?.edgeModules.length">N/A</span>

    <table *ngIf="deviceSummary?.edgeModules.length" mat-table [dataSource]="deviceSummary?.edgeModules" class="w-full" style="font-size: large;">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="w-[25%]">Name</th>
        <td mat-cell *matCellDef="let module">{{ module.name || 'N/A' }}</td>         
      </ng-container>

      <ng-container matColumnDef="image">
        <th mat-header-cell *matHeaderCellDef class="w-[75%]">Image</th>        
        <td mat-cell *matCellDef="let module">{{ module.image || 'N/A' }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['name', 'image']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['name', 'image'];"></tr>
    </table>
  </mat-dialog-content>

  <mat-dialog-actions class="flex flex-row justify-end content-end items-center w-full !py-4">

    <button mat-button type="submit" class="btn-primary btn-md" id="Done" [mat-dialog-close]="true" tabindex="0">
      Done
    </button>
  </mat-dialog-actions>
</div>
